import * as React from 'react';
import './index.css';
// eslint-disable-next-line import/no-unresolved
import { SOURCE_MULTI_SKU_NUM } from '@/components/MultiSkuModal/constant';
import Constant from '@/utils/constant';
import { debounce } from '@/utils/index';
import { GoodDetailData, ShopEntranceInfo } from '../../../../pages/shop/c_shop/component';
import TrackUtils from '../../utils/TrackUtils';

const WMRouter = Mach.requireModule('Router');

interface IProps {
  curGoodDetail: GoodDetailData;
  source?: number;
  renderMultiSpuView?: () => void;
  /** 一口价商品多spu的数量 */
  sameShopSpuListLength?: number;
  defaultImg?: string;
}

export default class GoodDetailFoodImage extends React.Component<IProps> {
  _renderMultiSpuView = () => {
    if (this.props.renderMultiSpuView) {
      return this.props.renderMultiSpuView();
    }
    return null;
  }

  onClickShopEntry = debounce((shopEntranceInfo: ShopEntranceInfo | undefined) => {
    // MC
    shopEntranceInfo?.shopId && TrackUtils.fixedPriceShopEntryMC(shopEntranceInfo.shopId);
    const scheme = `${Constant.SHOP_PAGE}&shopId=${shopEntranceInfo?.shopId}&categoryId=${shopEntranceInfo?.categoryId}&spuId=${shopEntranceInfo?.spuId}`;
    WMRouter.navigateTo(scheme);
  })

  _renderVisitShopEntry = (poisiton = 'top') => {
    const { curGoodDetail } = this.props;
    const { shopEntranceInfo } = curGoodDetail;
    // MV
    shopEntranceInfo?.shopId && TrackUtils.fixedPriceShopEntryMV(shopEntranceInfo.shopId);

    return (
      <view
        onClick={() => this.onClickShopEntry(shopEntranceInfo)}
        className={`${poisiton === 'top' ? 'visit-shop-container' : 'visit-shop-bottom-container'}`}
      >
        <image className="icon-spoon-fork" src="assets://fixprice/spoon_fork_icon.png" />
        <text className="visit-shop-text" content={shopEntranceInfo?.entranceText} />
        <image className="icon-spoon-fork" autoRTL src="assets://fixprice/icon_arrow_right_bold.png" />
      </view>
    );
  }

  render() {
    const { curGoodDetail, sameShopSpuListLength, defaultImg } = this.props;
    const { shopEntranceInfo } = curGoodDetail;
    const width = Mach.env.screenWidth;
    const imgUrl = defaultImg || curGoodDetail?.pictures[0];
    const height = Math.floor(Mach.env?.screenWidth * (3 / 4));
    const shopHeadImageCacheCDNParam = `${Mach.env.screenWidth * Mach.env.scale}.${height * Mach.env.scale}.100`;
    return (
      <view className="container">
        {imgUrl
          && (
            <view>
              <image
                resizeMode="aspectFill"
                className="image-view"
                style={{ width, height: Math.floor(height) }}
                src={imgUrl}
                cdnOptimizationSize={shopHeadImageCacheCDNParam}
                error="assets://placeholder/icon_placeholder_4:3.png"
                placeholder="assets://placeholder/icon_placeholder_4:3.png"
              />
              <view className="img-shadow" />
            </view>
          )}
        {this._renderMultiSpuView()}
        {this.renderAroundLabel()}
        {/* 有多个商品规格时，门店入口展示在标题上面 */}
        {
          shopEntranceInfo?.entranceText?.length && sameShopSpuListLength
            ? (
              <>
                {
                  this._renderVisitShopEntry('top')
                }
                <view className="visit-shop-separate-grey" />
              </>
            ) : null
        }
        <view className="detail-content-header">
          <text className="food-name" style={{ marginTop: this.props.renderMultiSpuView ? 4 : 16 }} content={curGoodDetail.name} />
          {!!curGoodDetail.description && <text className="food-description" content={curGoodDetail.description} />}
        </view>
        {/* 只有一个商品规格时，门店入口展示在标题下面 */}
        {
          shopEntranceInfo?.entranceText?.length && !sameShopSpuListLength
            ? this._renderVisitShopEntry('bottom') : null
        }
      </view>
    );
  }

  renderAroundLabel = () => {
    const { curGoodDetail, source } = this.props;
    const width = Mach.env.screenWidth;
    const height = (width * 3) / 4;
    const imgUrl = curGoodDetail?.pictures[0];
    const aroundLabel = curGoodDetail.aroundLabel;
    if (!aroundLabel) {
      return;
    }
    // 919活动颜色值
    const bgColor = source === SOURCE_MULTI_SKU_NUM.NINE_ONE_NINE ? 'linear-gradient(96deg, #F21111 0%, #FF5E00 100%)' : aroundLabel.bgColor;
    if (imgUrl) {
      return (
        <view
          className="around-label-container"
          style={{
            top: Math.floor(height) - 44,
            left: 0,
            width: Mach.env.screenWidth,
            backgroundColor: bgColor,
          }}
        >
          {aroundLabel?.icon?.length > 0 ? (<image className="around-label-icon" src={aroundLabel.icon} />) : null}
          <text className="around-label" content={aroundLabel.activityTitle} />
          <text className="around-label-sub" content={aroundLabel.limitText} />
        </view>
      );
    } else {
      return (
        <view
          className="around-label-container-no-image"
          style={{
            width: Mach.env.screenWidth - 32,
            backgroundColor: bgColor
          }}
        >
          {aroundLabel?.icon?.length > 0 ? (<image className="around-label-icon" src={aroundLabel.icon} />) : null}
          <text className="around-label" content={aroundLabel.activityTitle} />
          <text className="around-label-sub" content={aroundLabel.limitText} />
        </view>
      );
    }
  };
}
